import { LeadEmailBrandAssets } from '../data/types';
import { DEFAULT_LEAD_EMAIL_BRAND_ASSETS } from './leadEmailHtml';

const STORAGE_VERSION = 'v1';
const STORAGE_PREFIX = `homecook_leads_brand_defaults_${STORAGE_VERSION}`;

/** Build a versioned localStorage key scoped to the signed-in admin email. */
export const leadsAdminBrandStorageKey = (adminEmail?: string): string =>
  `${STORAGE_PREFIX}:${(adminEmail ?? 'anonymous').trim().toLowerCase()}`;

/** Parse persisted brand asset settings, falling back to HomeCook defaults. */
export const parseLeadsAdminBrandAssets = (raw: string | null): LeadEmailBrandAssets => {
  if (!raw) return { ...DEFAULT_LEAD_EMAIL_BRAND_ASSETS };
  try {
    const parsed = JSON.parse(raw) as Partial<LeadEmailBrandAssets>;
    return {
      logo_url:
        typeof parsed.logo_url === 'string' && parsed.logo_url.trim()
          ? parsed.logo_url.trim()
          : DEFAULT_LEAD_EMAIL_BRAND_ASSETS.logo_url,
      hero_image_url:
        typeof parsed.hero_image_url === 'string' && parsed.hero_image_url.trim()
          ? parsed.hero_image_url.trim()
          : DEFAULT_LEAD_EMAIL_BRAND_ASSETS.hero_image_url,
      feature_image_url:
        typeof parsed.feature_image_url === 'string' && parsed.feature_image_url.trim()
          ? parsed.feature_image_url.trim()
          : DEFAULT_LEAD_EMAIL_BRAND_ASSETS.feature_image_url,
      cta_image_url:
        typeof parsed.cta_image_url === 'string' && parsed.cta_image_url.trim()
          ? parsed.cta_image_url.trim()
          : DEFAULT_LEAD_EMAIL_BRAND_ASSETS.cta_image_url,
      source_community_id:
        typeof parsed.source_community_id === 'string' ? parsed.source_community_id : undefined,
      source_community_name:
        typeof parsed.source_community_name === 'string' ? parsed.source_community_name : undefined,
    };
  } catch {
    return { ...DEFAULT_LEAD_EMAIL_BRAND_ASSETS };
  }
};

/** Read persisted brand defaults from localStorage (browser only). */
export const loadLeadsAdminBrandAssets = (adminEmail?: string): LeadEmailBrandAssets => {
  if (typeof window === 'undefined') return { ...DEFAULT_LEAD_EMAIL_BRAND_ASSETS };
  return parseLeadsAdminBrandAssets(window.localStorage.getItem(leadsAdminBrandStorageKey(adminEmail)));
};

/** Write persisted brand defaults to localStorage (browser only). */
export const saveLeadsAdminBrandAssets = (
  adminEmail: string | undefined,
  assets: LeadEmailBrandAssets
): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(leadsAdminBrandStorageKey(adminEmail), JSON.stringify(assets));
};
